var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgItemLabelOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.2 47.6",
    style: {
      enableBackground: "new 0 0 39.2 47.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9,32.9v10.8H4.6V32.9H5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,34H7.1v-1.2h8V34h-3.3v9.6h-1.4V34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9,38.6h-4.2v3.9h4.7v1.2h-6.1V32.9h5.8V34h-4.4v3.4h4.2V38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,38.9c-0.1-1.5-0.2-3.3-0.2-4.7h0c-0.4,1.3-0.8,2.6-1.4,4.1l-1.9,5.2h-1.1L27,38.4c-0.5-1.5-0.9-2.9-1.2-4.2h0 c0,1.3-0.1,3.2-0.2,4.8l-0.3,4.6h-1.3l0.8-10.8h1.8l1.8,5.2c0.4,1.3,0.8,2.5,1.1,3.6h0c0.3-1.1,0.7-2.3,1.1-3.6l1.9-5.2h1.8 l0.7,10.8h-1.4L33.3,38.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33,26.5L10.1,3.7h17c0.9,0,1.6,0.2,2.1,0.5s1.1,0.9,1.5,1.5l8.4,11.9L33,26.5L33,26.5z M36.8,38.9l-7.7-7.7 c-0.2,0.2-0.5,0.3-0.9,0.4s-0.8,0.1-1.1,0.1H6.2c-0.8,0-1.5-0.3-2.1-0.9s-0.9-1.3-0.9-2.1v-21c0-0.5,0-0.8,0.2-1.1s0.2-0.5,0.3-0.8 L0,2.1L2.1,0l36.8,36.8L36.8,38.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLabelOff);
export default __webpack_public_path__ + "static/media/item-label-off.a099cdf2743be32372beb898bccb25c8.svg";
export { ForwardRef as ReactComponent };